<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <!-- activeIndex: {{activeIndex}} -->
          <!-- {{accountsOptions}}
          <hr />-->
          <!-- {{formParam}}
          -->
          <!-- {{broadcastParamSt}}
          <hr />
          {{broadcastParam}}-->
          <div class="row">
            <div class="col-md-6">
              <div class="col-md-12 profile-info-left">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label" data-tour-step="1">
                      Title
                      <span class="text text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" v-model="broadcastParam.title" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group row">
                    <label data-tour-step="2" class="col-form-label">
                      Message Options
                      <span class="text text-danger">*</span>
                    </label>
                    <select v-model="uploadMessageSupportSelected" class="form-control">
                      <option value>Options</option>
                      <option
                        v-for="(opt,index) in messageTypeOptionsSupport"
                        :value="opt"
                        :key="index"
                      >{{opt}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">
                <div class="form-group row">
                  <label data-tour-step="3" class="col-form-label">
                    Send From (Whatsapp)
                    <span class="text text-danger">*</span>
                  </label>
                  <!-- {{selectedLicense}} -->
                  <multiselect
                    v-model="selectedLicense"
                    id="ajax"
                    label="license_name"
                    track-by="id"
                    :placeholder="(typeof(selectedLicense)!='undefined' && typeof(selectedLicense.license_name)!='undefined'?selectedLicense.license_name:'')"
                    open-direction="bottom"
                    :custom-label="customLabelLicense"
                    :options="licenseOptions"
                    :multiple="true"
                    :searchable="true"
                    :loading="isLoadingLicense"
                    :internal-search="false"
                    :close-on-select="false"
                    :options-limit="300"
                    :limit="3"
                    :limit-text="limitText"
                    :max-height="600"
                    :show-no-results="true"
                    :hide-selected="true"
                    @search-change="asyncFindLicenseSelect"
                    :show-labels="false"
                  >
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{ option.license_name+" ("+option.license_phone_number+")" }}</span>
                        <span class="custom__remove" @click="remove(option)">❌</span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="typeof(selectedLicense.length)!='undefined' && selectedLicense.length"
                        @mousedown.prevent.stop="clearAllLicense(props.search)"
                      ></div>
                    </template>
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <label data-tour-step="4" class="col-form-label">
                    Recipients
                    <span class="text text-danger">*</span>
                  </label>
                  <table class="table borderless">
                    <tbody>
                      <tr>
                        <td style="width:20%;">
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='group'"
                          >Group</button>
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-else-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags'"
                          >Tags</button>
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-else
                          >Contact</button>
                          <div class="dropdown-menu">
                            <a
                              @click.prevent="changeDestination(1,'group')"
                              class="dropdown-item"
                              href="#"
                            >
                              <i
                                :class="((broadcastParam.is_group==1 && broadcastParam.is_group_type=='group')?'text-success':'')+' fa fa-users'"
                              ></i>
                              Group
                            </a>
                            <a
                              @click.prevent="changeDestination(1,'tags')"
                              class="dropdown-item"
                              href="#"
                            >
                              <i
                                :class="((broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags')?'text-success':'')+' fa fa-tags'"
                              ></i>
                              Tags
                            </a>
                            <a
                              @click.prevent="changeDestination(0,'')"
                              class="dropdown-item"
                              href="#"
                            >
                              <i
                                :class="((broadcastParam.is_group==0)?'text-success':'')+' fa fa-user'"
                              ></i>
                              Contact
                            </a>
                          </div>
                        </td>
                        <td>
                          <multiselect
                            v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='group'"
                            v-model="selectedContactGroup"
                            id="ajax"
                            label="name"
                            track-by="id"
                            placeholder="Type to search group"
                            open-direction="bottom"
                            :custom-label="customLabelGroup"
                            :options="contactOptionsGroup"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoadingGroup"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFindGroup"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContactGroup.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                          <multiselect
                            v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags'"
                            v-model="tagsSelected"
                            placeholder="Type to search tags"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :multiple="true"
                            :custom-label="tagsCustomLabel"
                            :options="tagsOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="tagsLimitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="tagsAsyncFind"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="tagsSelected.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                          <!-- {{selectedContact}} -->
                          <multiselect
                            v-if="broadcastParam.is_group==0"
                            v-model="selectedContact"
                            id="ajax"
                            label="first_name"
                            track-by="phone_number"
                            placeholder="Type to search contact"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="contactOptions"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFind"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span
                                  v-if="option.is_group==1"
                                >{{ option.first_name +" ("+ option.provider+")" }}</span>
                                <span v-else>{{ option.first_name +" ("+ option.phone_number+")" }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContact.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="input-group m-b-30">
                    <div class="input-group-prepend"></div>
                    <div class="input-group-append"></div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-tour name="tourGuide1" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tourId: "broadcast.step1",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Judul pesan broadcast`
        },
        {
          target: '[data-tour-step="2"]',
          content: `Jenis pesan yang akan dikirim
          <br /><ul>
          <li><b>Text Only</b>: Hanya mengirimkan pesan teks.</li>
          <li><b>Media</b>: Mengirimkan pesan teks, gambar ataupun dokumen.</li>
          </ul>
          `
        },
        {
          target: '[data-tour-step="3"]',
          content: "Lisensi/Akun whatsapp yang digunakan sebagai pengirim."
        },
        {
          target: '[data-tour-step="4"]',
          content: `Penerima pesan broadcast
          <br />  <ul>
          <li><b>Group</b>: Beberapa nomor whastapp dikelompokkan dalam 1 grup.</li>
          <li><b>Tags</b>: Kategori nomor whatsapp yang dibuat melalui fitur Chat Waajo.</li>
          <li><b>Contact</b>: Nomor whatsapp yang ada di daftar Kontak Waajo.</li>
          </ul>
          `
        }
      ],
      tagsSelected: [],
      tagsOptions: [],
      tagsListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      contactListGroupParam: {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      selectedContactGroup: [],
      contactOptionsGroup: [],
      isLoadingGroup: false,
      selectedContact: [],
      contactOptions: [],
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      isSending: false,
      dataListMonitoringStatus: [],
      broadcastParam: {
        broadcast_id: "",
        title: "",
        license_id: "",
        to_group: [],
        to: [],
        is_group: 1, //for group set 1, for personal set 0
        is_group_type: "group", //group/tags
        message: {
          text: "",
          message_type: "text", //text,image,document
          file_url: ""
        },
        interactive_message_status: false,
        interactive_message_type: "button_text",
        buttons: ["", "", "", "", "", "", "", "", "", ""]
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      isLoading: false,
      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      }
    };
  },
  watch: {
    tagsSelected: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to_group = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: 0,
              phone_number_group: "",
              is_group: 1,
              first_name: row.name,
              name: row.name
            };
            this.broadcastParam.to_group.push(newDest);
          });
        } else {
          this.broadcastParam.to_group = [];
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: row.phone_number,
              phone_number_group: row.phone_number_group,
              is_group: row.is_group,
              first_name: row.first_name,
              provider: row.provider
            };
            this.broadcastParam.to.push(newDest);
          });
        } else {
          this.broadcastParam.to = [];
        }
      },
      deep: true
    },
    selectedContactGroup: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to_group = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: 0,
              name: row.name,
              first_name: row.name,
              phone_number_group: "",
              is_group: 1
            };
            this.broadcastParam.to_group.push(newDest);
          });
        } else {
          this.broadcastParam.to_group = [];
        }
      },
      deep: true
    },
    broadcastParamSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal && val.id != "") {
          var that = this;
          setTimeout(function() {
            if (
              that.broadcastParamSt.broadcast_id != "" &&
              that.broadcastParamSt.broadcast_id != null
            ) {
              that.selectedLicense = [];

              that.broadcastParam = that.broadcastParamSt;
              that.broadcastParam.title = that.detailBroadcast.title;
              if (that.broadcastParam.license_id != "") {
                that.asyncFindLicense("", that.broadcastParam.license_id);
              }
              if (that.detailBroadcast.is_group == 0) {
                that.selectedContact = that.broadcastParam.to;
              } else if (that.detailBroadcast.is_group == 1) {
                if (that.broadcastParam.is_group_type == "tags") {
                  that.tagsSelected = that.broadcastParam.to_group;
                } else {
                  that.selectedContactGroup = that.broadcastParam.to_group;
                }
              }

              that.broadcastParam.message.message_type =
                that.detailBroadcast.message_type;
              that.broadcastParam.message.file_url =
                that.detailBroadcast.message_media;
              // console.log("that.broadcastParam.message.file_url",that.broadcastParam.message.file_url)
              if (that.broadcastParam.message.message_type != "text") {
                that.uploadMessageType =
                  that.broadcastParam.message.message_type;
                that.updateMessageSupportCurrent("media");
              } else {
                that.updateMessageSupportCurrent("text only");
              }
            }
          }, 200);
        }
      },
      deep: true
    },
    broadcastParam: {
      handler: function(val, oldVal) {
        // if (val != oldVal) {
        // console.log("oldVal", oldVal);
        // console.log("newVal", val);
        this.formValidate();
        // }
      },
      deep: true
    },
    selectedLicense: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function() {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.broadcastParam.license_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.broadcastParam.license_id = val[0].id;

          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.broadcastParam.license_id = "";

          return;
        }
        // else {
        //   this.selectedLicense = [];
        //   this.broadcastParam.license_id = "";
        //   return;
        // }
        // }
      },
      deep: true
    },
    uploadMessageSupportSelected: {
      handler: function(val, oldVal) {
        if (val == "media") {
          this.broadcastParam.message.message_type = this.uploadMessageType;
        } else {
          this.files = [];
          this.broadcastParam.message.file_url = "";
          this.broadcastParam.message.message_type = "text";
        }
        this.formValidate();
      },
      deep: true
    },
    uploadMessageType: {
      handler: function(val, oldVal) {
        if (val != "") {
          this.broadcastParam.message.message_type = val;
        } else {
          this.broadcastParam.message.message_type = "text";
        }
      },
      deep: true
    },
    activeIndex: {
      handler: function(val, oldVal) {
        //   console.log("val", val, "oldVal", oldVal);
        //   if (val == true) {
        //     // console.log("active index")
        //     // this.selectedLicense = [];
        //     var that = this;
        //     setTimeout(function() {
        //       if (val == 0) {
        //         that.tourDetail();
        //       }
        //       // console.log("that.broadcastParamSt", that.broadcastParamSt);
        //       // that.formPar
        //       // that.asyncFindProduct();
        //       // console.log("")
        //     }, 100);
        //   }
        //   // if (val == 0) {
        //   //   this.tourDetail();
        //   // }
      },
      deep: true
    }
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    tourShow() {
      this.$tours["tourGuide1"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.keywords = query;
      this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data;
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    customLabel({ first_name, phone_number, provider, is_group }) {
      if (is_group == 1) {
        return `${first_name} – ${provider}`;
      } else {
        return `${first_name} – ${phone_number}`;
      }
    },
    tagsLimitText(count) {
      return ` ${count} other`;
    },
    tagsCustomLabel({ name }) {
      return `${name}`;
    },
    tagsAsyncFind(query) {
      this.isLoading = true;
      this.tagsListParam.name = query;
      this.$store
        .dispatch("crm/listTagsBC", this.tagsListParam)
        .then(response => {
          this.isLoading = false;
          this.tagsOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabelGroup({ name }) {
      return `${name}`;
    },
    formValidate() {
      let newParam = this.broadcastParamSt;
      //   newParam = currentParam;
      newParam.title = this.broadcastParam.title;
      newParam.license_id = this.broadcastParam.license_id;
      newParam.uploadMessageType = this.uploadMessageType;
      newParam.to_group = this.broadcastParam.to_group;
      newParam.to = this.broadcastParam.to;
      newParam.is_group = this.broadcastParam.is_group;
      newParam.is_group_type = this.broadcastParam.is_group_type;
      newParam.message = this.broadcastParam.message;

      this.$store.dispatch("omniwa/actBroadcastParamSt", newParam);
      //   console.log("newParam", newParam);
    },

    customLabelLicense({ license_name, license_phone_number }) {
      if (typeof license_name != "undefined") {
        return `${license_name} – ${license_phone_number}`;
      }
    },
    asyncFindLicenseSelect(query) {
      // if (query == "") {
      //   return false;
      // }
      this.licenseOptions = [];
      // this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      // if (query == "") {
      //   return;
      // }

      this.licenseListParam.id = "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          // this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);

          // console.log("query: ", query);
          // console.log("contactOptions: ", this.licenseOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          // this.isLoadingLicense = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    asyncFindLicense(query, id) {
      // if (query == "") {
      //   return false;
      // }
      // this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      if (typeof id != "undefined" && id != "") {
        this.licenseListParam.id = id;
      } else {
        this.licenseListParam.id = "";
      }
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);
          if (
            typeof id != "undefined" &&
            id != "" &&
            this.licenseOptions.length > 0
          ) {
            this.selectedLicense = this.licenseOptions;
          }
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.licenseOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingLicense = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAllLicense() {
      this.selectedLicense = [];
    },
    async buildDestinationFromGroup() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      await this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          let { data } = response;
          data.forEach((rowCon, ind) => {
            let arrCon = {
              id: rowCon.id,
              phone_number: rowCon.phone_number,
              is_group: rowCon.is_group,
              phone_number_group: rowCon.phone_number_group
            };
            this.broadcastParam.to.push(arrCon);
          });
        });
    },
    async buildDestinationFromTags() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      await this.$store
        .dispatch("contact/getContactListFromTags", this.contactListParam)
        .then(response => {
          let { data } = response;
          data.forEach((rowCon, ind) => {
            let arrCon = {
              id: rowCon.id,
              phone_number: rowCon.phone_number,
              is_group: rowCon.is_group,
              phone_number_group: rowCon.phone_number_group
            };
            this.broadcastParam.to.push(arrCon);
          });
        });
    },
    customLabelGroup({ name }) {
      return `${name}`;
    },
    asyncFindGroup(query) {
      // console.log("query", query);
      this.isLoadingGroup = true;
      this.contactListGroupParam.name = query;
      this.$store
        .dispatch("contact/getGroupList", this.contactListGroupParam)
        .then(response => {
          this.isLoadingGroup = false;
          this.contactOptionsGroup = response.data;
          // console.log("query: ", query);
          // console.log("contactOptionsGroup: ", this.contactOptionsGroup);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingGroup = false;
        });
    },
    changeDestination(isGroup, isGroupType) {
      this.broadcastParam.is_group = isGroup;
      this.broadcastParam.is_group_type = isGroupType;
      this.broadcastParam.to = [];
      this.broadcastParam.to_group = [];
      this.selectedContactGroup = [];
      this.tagsSelected = [];
      this.selectedContact = [];
      this.contactListParam = {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
      this.contactListGroupParam = {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
      this.tagsListParam = {
        name: "",
        page: 0,
        perPage: 10
      };
    }
  },
  async created() {
    this.tourDetail();

    this.asyncFindLicenseSelect();
    this.$root.$on(
      "on-validate",
      validationResult => {
        // console.log("validationResult", validationResult);
      },
      activeTabIndex => {
        // console.log("activeTabIndex", activeTabIndex);
      }
    );
  },
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form1-accounts"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/components/form1.vue